import { useState } from "react";
import { useHistory } from "react-router-dom";
import { FaEnvelope, FaLocationArrow, FaMapMarked, FaPhone, FaTransgender, FaUser } from 'react-icons/fa';
import Layout from "../cponents/layout"
import BaseEndpoint from "../endpoints/baseEndpoint";
import { useForm } from "react-hook-form";
import { useEffect } from "react";

export default function Login() {
    const [section, setSection] = useState('login'); // 'login' or 'register
    const history = useHistory();

    const [content, setContent] = useState({
        image: '/assets/images/register.svg',
        terms: '',
    });
    useEffect(() => {
        let authUser = JSON.parse(localStorage.getItem('authUser'));
        if (authUser && authUser.token) {
            setSection('register');
        }

        BaseEndpoint.instance().get("/register").then((response) => {
            if (response.data.success)
                setContent(response.data.data);
        });
    }, []);

    const loginForm = useForm({
        defaultValues: {
            token: "",
            password: ""
        }
    });
    const registerForm = useForm({
        defaultValues: {
            name: "",
            ttl: "",
            gender: "",
            email: "",
            phone: "",
            address: "",
            terms: false,
        }
    });
    const terms = registerForm.watch('terms');

    const onLoginSubmit = (data) => {
        BaseEndpoint.instance().post("/token", data).then((response) => {
            if (response.data.to || (response.data.data && response.data.data.to_ta)) {
                let userData = response.data.to ? response.data.data : response.data.data.participant;
                localStorage.setItem('authUser', JSON.stringify(userData));
                history.push('/app');
            } else {
                localStorage.setItem('authUser', JSON.stringify({
                    token: data.token,
                }))
                setSection('register');
            }
        }).catch((error) => {
            // set errors manually in react-hook-form
            if (error.response.status !== 200) {
                Object.keys(error.response.data.errors).map((value, index) => {
                    loginForm.setError(value, { type: 'custom', message: error.response.data.errors[value][0] })
                })
            }
        });
    }

    const onRegisterSubmit = (data) => {
        let authUser = JSON.parse(localStorage.getItem('authUser'));
        let newData = { ...data, ...authUser };
        BaseEndpoint.instance().post("/register", newData).then((response) => {
            localStorage.setItem('authUser', JSON.stringify({
                ...authUser,
                ...response.data.data,
            }))

            history.push("/app");
        }).catch((error) => {
            // set errors manually in react-hook-form
            if (error.response && error.response.status !== 200) {
                Object.keys(error.response.data.errors).map((value, index) => {
                    registerForm.setError(value, { type: 'custom', message: error.response.data.errors[value][0] })
                })
            }
        });
    }

    return (
        <Layout>
            {'login' === section ? (
                <div className="container mx-auto row items-center py-5" style={{ minHeight: "80vh" }}>
                    <div className="col-md-6 d-flex align-items-center">
                        <div className="p-3">
                            <h2 className="mb-4 lh-base">Sudah siap untuk mengukur kemampuanmu?</h2>
                        </div>
                        <img src="/assets/images/login.svg" alt="" className="img-fluid w-100" style={{ maxWidth: "350px" }} />
                    </div>
                    <div className="col-md-6 ps-5 d-flex flex-column justify-content-center">
                        <h2>Masukkan kode aktivasi anda</h2>
                        <form className="mt-4" onSubmit={loginForm.handleSubmit(onLoginSubmit)}>
                            <div className="mb-4">
                                <input {...loginForm.register('token', {
                                    required: "Kode aktivasi tidak boleh kosong"
                                })} type="text" className="form-control border-0 border-bottom rounded-0" placeholder="Kode aktivasi" />
                                {loginForm.formState.errors.token && <span className="d-block mt-2 text-danger">{loginForm.formState.errors.token.message}</span>}
                            </div>
                            <div className="mb-4">
                                <input {...loginForm.register('password', {
                                    required: "Kata sandi tidak boleh kosong"
                                })} name="password" type="password" className="form-control border-0 border-bottom rounded-0" placeholder="Kata sandi" />
                                {loginForm.formState.errors.password && <span className="d-block mt-2 text-danger">{loginForm.formState.errors.password.message}</span>}
                            </div>
                            <div className="actions mb-4">
                                <button type="submit" className="btn btn-primary rounded-pill w-100 px-4 py-2 text-white">Masuk</button>
                            </div>
                        </form>
                    </div>
                </div>
            ) : (
                <div className="container mx-auto row items-center py-5" style={{ minHeight: "80vh" }}>
                    <div className="col-md-6 d-flex align-items-center">
                        <img src={content.image} alt="" className="img-fluid w-100" />
                    </div>
                    <div className="col-md-6 ps-5 d-flex flex-column justify-content-center">
                        <h2>Masukkan data dirimu</h2>
                        <form className="mt-4" onSubmit={registerForm.handleSubmit(onRegisterSubmit)}>
                            <div>
                                <div className="mb-4 d-flex align-items-center">
                                    <FaUser className="me-3 fs-4 text-primary" />
                                    <input {...registerForm.register('name', {
                                        required: 'Nama tidak boleh kosong'
                                    })} type="text" className="form-control border-0 border-bottom rounded-0" placeholder="Nama" />
                                </div>
                                {registerForm.formState.errors.name && <span className="d-block mb-2 text-danger">{registerForm.formState.errors.name.message}</span>}
                            </div>
                            <div>
                                <div className="mb-4 d-flex align-items-center">
                                    <FaLocationArrow className="me-3 fs-4 text-primary" />
                                    <input {...registerForm.register('ttl', {
                                        required: 'Tempat lahir tidak boleh kosong'
                                    })} type="text" className="form-control border-0 border-bottom rounded-0" placeholder="Tempat & Tanggal Lahir" />
                                </div>
                                {registerForm.formState.errors.ttl && <span className="d-block mb-2 text-danger">{registerForm.formState.errors.ttl.message}</span>}
                            </div>
                            <div>
                                <div className="mb-4 d-flex align-items-center">
                                    <FaTransgender className="me-3 fs-4 text-primary" />
                                    <select {...registerForm.register('gender', {
                                        required: 'Jenis kelamin tidak boleh kosong'
                                    })} className="form-control border-0 border-bottom rounded-0">
                                        <option value="">Jenis kelamin</option>
                                        <option value="L">Laki-laki</option>
                                        <option value="P">Perempuan</option>
                                    </select>
                                </div>
                                {registerForm.formState.errors.gender && <span className="d-block mb-2 text-danger">{registerForm.formState.errors.gender.message}</span>}
                            </div>
                            <div>
                                <div className="mb-4 d-flex align-items-center">
                                    <FaEnvelope className="me-3 fs-4 text-primary" />
                                    <input {...registerForm.register('email', {
                                        required: 'Email tidak boleh kosong'
                                    })} type="email" className="form-control border-0 border-bottom rounded-0" placeholder="Alamat email" />
                                </div>
                                {registerForm.formState.errors.email && <span className="d-block mb-2 text-danger">{registerForm.formState.errors.email.message}</span>}
                            </div>
                            <div>
                                <div className="mb-4 d-flex align-items-center">
                                    <FaPhone className="me-3 fs-4 text-primary" />
                                    <input {...registerForm.register('phone', {
                                        required: 'No. Telepon tidak boleh kosong'
                                    })} type="text" className="form-control border-0 border-bottom rounded-0" placeholder="No. Telepon" />
                                </div>
                                {registerForm.formState.errors.phone && <span className="d-block mb-2 text-danger">{registerForm.formState.errors.phone.message}</span>}
                            </div>
                            <div>
                                <div className="mb-4 d-flex align-items-center">
                                    <FaMapMarked className="me-3 fs-4 text-primary" />
                                    <textarea {...registerForm.register('address', {
                                        required: 'Alamat tidak boleh kosong'
                                    })} className="form-control border-0 border-bottom rounded-0" placeholder="Alamat Lengkap" />
                                </div>
                                {registerForm.formState.errors.address && <span className="d-block mb-2 text-danger">{registerForm.formState.errors.address.message}</span>}
                            </div>
                            <div className="mb-4">
                                <label htmlFor="terms">
                                    <input {...registerForm.register('terms', {
                                        required: 'Anda harus menyetujui syarat dan ketentuan'
                                    })} id="terms" type="checkbox" className="me-3" />
                                    Saya setuju dengan <a data-bs-toggle="modal" data-bs-target="#termConditionModal" href="#" className="text-decoration-none text-primary">syarat dan ketentuan</a> yang berlaku
                                </label>
                            </div>
                            <div className="actions mb-4">
                                <button type="submit" className="btn btn-primary rounded-pill w-100 px-4 py-2 text-white" disabled={!terms}>Masuk</button>
                            </div>
                        </form>
                    </div>
                    <div className="modal fade" id="termConditionModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h1 className="modal-title fs-5" id="exampleModalLabel">Syarat dan Ketentuan</h1>
                                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                </div>
                                <div className="modal-body">
                                    <div dangerouslySetInnerHTML={{ __html: content.terms }}></div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </Layout>
    )
}